import { isHarnessFlagsSource } from "@/config/flags/flagsSource";
import { getSplitClient } from "@/config/split/splitClient";

const CLIENT_POLL_MS = 100;
const DEFAULT_TIMEOUT_MS = 3000;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const whenFlagsReady = async (
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<void> => {
  if (!isHarnessFlagsSource()) return;

  const deadline = Date.now() + timeoutMs;
  while (!getSplitClient() && Date.now() < deadline) {
    await delay(CLIENT_POLL_MS);
  }

  const client = getSplitClient();
  if (!client) return;

  await Promise.race([
    client.ready().catch(() => {}),
    delay(Math.max(deadline - Date.now(), 0)),
  ]);
};
